import axios from "axios";

const baseURL = process.env.VUE_APP_API_BASE_URL;

const reOpen = axios.create({
  baseURL: baseURL
});


class CareUserActivity {
  userActivityLog(val) {
    return reOpen.post('/careUserActivity', val)
  }
  
  userHelpTopicLog(helpVal) {
    return reOpen.post('/careUserActivity/helpTopicsReport', helpVal)
  }

}

export default new CareUserActivity();
